import news from '@/api/administrator/news'
import lang from '@/api/lang'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  lang_id: 1
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_LANG(state, lang_id) {
    state.lang_id = lang_id
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        filter: {
          lang_id: context.state.lang_id
        }
      },
      attrubutes
    )
    return news.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return news.store(data)
  },
  update(context, { id, data }) {
    return news.update(id, data)
  },
  destroy(context, id) {
    return news.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await news.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getLang(context) {
    return lang.get()
  },
  upload(context, data) {
    return news.uploadImage(data)
  }
}
